<template>
    <div>
        <b-form-group :id="'fieldset-' + id" v-bind="$attrs">
            <b-row>
                <b-col cols="12">
                    <b-input-group class="position-static input-datepicker-range mb-3">
                        <b-input-group-prepend class="position-static">
                            <b-form-datepicker
                                boundary="viewport"
                                v-model="inputModelFrom"
                                button-only
                                locale="en-US"
                                aria-controls="input-datepicker"
                                size="sm"
                                class="bg-transparent boundary-datepicker"
                                @input="setDateFrom"
                                v-bind="$attrs" 
                                :max="inputModelTo"
                            ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                            id="example-input"
                            v-model="inputModelFromStr"
                            type="text"
                            placeholder="dd/MM/yyyy"
                            autocomplete="off"
                            size="sm"
                            readonly
                        ></b-form-input>
                        <b-input-group-append v-if="inputModelFromStr">
                            <b-button size="sm" variant="outline-danger" @click="clearDateFrom"><b-icon-x /></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col cols="12">
                    <b-input-group class="position-static input-datepicker-range mb-3">
                        <b-input-group-prepend class="position-static">
                            <b-form-datepicker
                                boundary="viewport"
                                v-model="inputModelTo"
                                button-only
                                locale="en-US"
                                aria-controls="input-datepicker"
                                size="sm"
                                class="bg-transparent boundary-datepicker"
                                @input="setDateTo"
                                v-bind="$attrs" 
                                :min="inputModelFrom"
                            ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                            id="example-input"
                            v-model="inputModelToStr"
                            type="text"
                            placeholder="dd/MM/yyyy"
                            autocomplete="off"
                            size="sm"
                            readonly
                        ></b-form-input>
                        <b-input-group-append v-if="inputModelToStr">
                                <b-button size="sm" variant="outline-danger" @click="clearDateTo"><b-icon-x /></b-button>
                            </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-form-invalid-feedback :id="'input-' + id + '-live-feedback'">
                {{ errorMessage }}
            </b-form-invalid-feedback>
        </b-form-group>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    props: ["modelFrom", "modelTo", "errorMessage", "id", "suffix", "prefix", "isEditable", "isUpdatable", "dateToDropupRight"],
    data() {
        return {
            inputModelFrom: this.modelFrom,
            inputModelFromStr: '',
            inputModelTo: this.modelTo,
            inputModelToStr: '',
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            inputDateToDropupRight: (this.dateToDropupRight ? true : false)
        }
    }, 
    methods: {
        setDateFrom() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelFrom != '') {
                inputModelDate = this.inputModelFrom;
            }
            
            let date = new Date(inputModelDate);
            if (date) {
                this.inputModelFromStr = moment(date).format('DD/MM/YYYY');
            }
            this.$emit('update:modelFrom', this.inputModelFrom);
            this.$emit('change')
        },
        setDateTo() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelTo != '') {
                inputModelDate = this.inputModelTo;
            }
            
            let date = new Date(inputModelDate);
            if (date) {
                this.inputModelToStr = moment(date).format('DD/MM/YYYY');
            }
            this.$emit('update:modelTo', this.inputModelTo);
            this.$emit('change')
        },
        clearDateFrom() {
            this.inputModelFromStr = '';
            this.inputModelFrom = '';
            this.$emit('update:modelFrom', this.inputModelFrom);
            this.$emit('change');
        },
        clearDateTo() {
            this.inputModelToStr = '';
            this.inputModelTo = '';
            this.$emit('update:modelTo', this.inputModelTo);
            this.$emit('change');
        }
    },
    mounted() {
        if (this.inputModelFrom != null && this.inputModelFrom != "" && this.inputModelFrom != undefined) {
            let date = new Date(this.inputModelFrom);
            if (date) {
                this.inputModelFromStr = moment(date).format('DD/MM/YYYY');
            }
        }
        if (this.inputModelTo != null && this.inputModelTo != "" && this.inputModelTo != undefined) {
            let date = new Date(this.inputModelTo);
            if (date) {
                this.inputModelToStr = moment(date).format('DD/MM/YYYY');
            }
        }
    },
    watch: {
        modelFrom(newValue, oldValue) {
            if (newValue == "") {
                this.inputModelFrom = newValue;
            }
        },
        modelTo(newValue, oldValue) {
            if (newValue == "") {
                this.inputModelTo = newValue;
            }
        }
    }
}
</script>
<style scoped lang="scss">
.input-group-text {
    font-size: 0.7rem !important;
}

::v-deep.input-datepicker-range, .input-datepicker-range label {
    line-height: 1.75 !important;
}

::v-deep.btn.btn-secondary, ::v-deep.btn.btn-secondary:active, ::v-deep.btn.btn-secondary:hover {
        background-color: transparent !important;
    }
    ::v-deep.form-control:disabled, .form-control[readonly] {
        background-color: transparent !important;
    }
    ::v-deep::placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep:-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep::-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }
</style>